/*
export * from './PrivateRoutes'
export * from './PublicRoutes'
export * from './AppRouter'
*/

import {PrivateRoutes } from './PrivateRoutes';
import { PublicRoutes } from './PublicRoutes';
import { AppRouter } from './AppRouter';

export{
    PrivateRoutes,
    PublicRoutes,
    AppRouter
}